
console.log('🚀 DynamicFormGenerator.tsx file is being loaded!');

import { createScaffolderFieldExtension, FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import React, { useState } from 'react';
import type { FieldValidation } from '@rjsf/utils';

console.log('📦 DynamicFormGenerator imports successful!');
import { useApi, identityApiRef, configApiRef } from '@backstage/core-plugin-api'; // ⬅️ ¡Importaciones clave!
import { withTheme } from '@rjsf/core';
import { Theme as RJSFTheme } from '@rjsf/material-ui'; // or '@rjsf/material-ui' if using material-ui v4
import validator from '@rjsf/validator-ajv8'; // Necesitas un validador (AJV es el estándar)

const Form = withTheme(RJSFTheme);


export const DynamicFormGeneratorField = (props: FieldExtensionComponentProps<string>) => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const SYS_INFO_BACKEND_URL = 'backend.baseUrl';
  const backendUrl = config.getString(SYS_INFO_BACKEND_URL);

  // Access the template config from the global form data (from previous step)
  // In Backstage scaffolder, previous step data is available through formContext
  const formContext = (props as any).formContext;
  const globalFormData = formContext?.formData || {};
  const templateConfig = globalFormData.templateConfig;
  const selectedBranch = templateConfig?.branch;
  const selectedTemplate = templateConfig?.template;
  // Always use the current version of the template (no version selector)
  const selectedVersion = templateConfig?.version || 'latest';
  const applicationId = formContext?.formData?.applicationProject.application;
  const projectId = formContext?.formData?.applicationProject.project;
  const applicationDivision = formContext?.formData?.applicationProject?.applicationDivision;
  const repository = formContext?.formData?.componentName;

  console.log('Application ID:', applicationId);
  console.log('Project ID:', projectId);

  console.log('📦 Template config received:', templateConfig);
  console.log('📦 Selected template:', selectedTemplate);
  console.log('📦 Selected version:', selectedVersion);
  console.log('📦 Global formData:', globalFormData);
  console.log('📦 FormContext:', formContext);

  const [schema, setSchema] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    console.log('🎯 DynamicFormGenerator mounted!');
    // Solo llamar a la API si template y branch están definidos
    if (selectedTemplate && selectedBranch) {
      console.log('🔍 Making API call with template:', selectedTemplate, 'version:', selectedVersion, 'branch:', selectedBranch);
      fetchSchema(selectedTemplate, selectedVersion, selectedBranch);
    }
    // Si solo hay template pero no version, no hacer nada
  }, [selectedTemplate, selectedBranch]);

  const fetchSchema = async (template: string, version: string, branch: string) => {
    setLoading(true);
    console.log('Fetching schema for template:', template, 'version:', version);
    try {
      const token = (await identityApi.getCredentials()).token;
      const response = await fetch(`${backendUrl}/api/devops-api-proxy/template-payload/${template}/${version}?templateBranch=${encodeURIComponent(branch)}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const payloadData = await response.json();
      const divisionField =
        payloadData.editorSchema.properties.metadata.properties.division;

      // ✅ Caso 1: viene informada
      if (applicationDivision) {
        divisionField.default = applicationDivision;
        divisionField.readOnly = true;
      } else {
        // ✅ Caso 2: NO viene → usuario debe rellenarlo
        divisionField.readOnly = false;
      }
      payloadData.editorSchema.properties.metadata.properties.businessAppId.default = applicationId;
      payloadData.editorSchema.properties.metadata.properties.businessAppId.readOnly = true;
      payloadData.editorSchema.properties.metadata.properties.projectId.default = projectId;
      payloadData.editorSchema.properties.metadata.properties.projectId.readOnly = true;
      payloadData.editorSchema.properties.metadata.properties.repository.default = repository;
      payloadData.editorSchema.properties.metadata.properties.repositoryType.readOnly = true;
      console.log('📋 Template payload fetched:', payloadData);

      // Extract the schema from the editorSchema field
      const editorSchema = payloadData.editorSchema;
      if (!editorSchema) {
        throw new Error('No editorSchema found in the response');
      }

      console.log('📋 Editor schema extracted:', editorSchema);
      setSchema(editorSchema);
    } catch (error) {
      console.error('❌ Error fetching schema:', error);
      setSchema(null);
    } finally {
      setLoading(false);
    }
  };

  // Handle form data changes from the dynamic form
  const handleFormChange = (data: any) => {
    console.log('🔧 Dynamic form data changed:', data.formData);
    // Pass the form data to the scaffolder
    props.onChange(data.formData);
  };

  // Render the dynamic form or loading/error states
  return (
    <div style={{
      // border: '2px solid #1976d2', 
      padding: '20px',
      margin: '10px 0',
      // backgroundColor: '#2a3244ff',
      borderRadius: '8px'
    }}>
      <h3 style={{ margin: '0 0 15px 0', color: '#1976d2' }}>
        🔧 Configuration for {selectedTemplate || 'Unknown Template'} v{selectedVersion || 'Unknown'}
      </h3>

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>⏳ Loading schema for {selectedTemplate} v{selectedVersion}...</p>
        </div>
      )}

      {!loading && !schema && selectedTemplate && selectedVersion && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#d32f2f' }}>
          <p>❌ Failed to load schema for {selectedTemplate} v{selectedVersion}</p>
          <button
            onClick={() => fetchSchema(selectedTemplate, selectedVersion, selectedBranch)}
            style={{
              padding: '8px 16px',
              // backgroundColor: '#1976d2', 
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            🔄 Retry
          </button>
        </div>
      )}

      {!selectedTemplate && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#ff9800' }}>
          <p>⚠️ Please select a template in the previous step</p>
        </div>
      )}

      {schema && (
        <div>
          <div style={{
            // backgroundColor: '#373a46ff', 
            padding: '15px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '10px' // Reduced font size for the entire form
          }}>
            <Form
              schema={schema}
              formData={props.formData || {}}
              onChange={handleFormChange}
              validator={validator}
              showErrorList={false}
              liveValidate={true}
              uiSchema={{
                businessAppId: { "ui:readonly": true },
                projectId: { "ui:readonly": true },
              }}
            >
              <div style={{ display: 'none' }}>
                {/* Hide the submit button since scaffolder handles submission */}
                <button type="submit">Submit</button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export const dinamicFormGeneratorCaseValidation = (
  value: string,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('This field is required.');
    return;
  }
};

// 4. REGISTRO DE LA EXTENSIÓN
console.log('📝 Creating DynamicFormGenerator field extension...');

// Create the extension using the proper plugin pattern
export const DynamicFormGeneratorCaseFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DynamicFormGeneratorField', // Must match ui:field in template.yaml
    component: DynamicFormGeneratorField,
    validation: dinamicFormGeneratorCaseValidation,
  }),
);

console.log('🔍 DynamicFormGenerator extension created:', DynamicFormGeneratorCaseFieldExtension);
console.log('✅ DynamicFormGenerator field extension created with name: DynamicFormGenerator');